export enum METHOD {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export interface IAxiosRequestOptions<
  M,
  D extends Dictionary = Dictionary,
  Q extends Dictionary = Dictionary,
> {
  defaultData: Partial<D>;
  defaultQuery: Partial<Q>;
  headers: Dictionary;
  method: M | METHOD;
  url: string;
}

export default abstract class AxiosRequestOptions<
  M,
  D extends Dictionary = Dictionary,
  Q extends Dictionary = Dictionary,
> implements IAxiosRequestOptions<M, D, Q> {
  method: M | METHOD;

  url = '';

  headers: Dictionary = {
    'Content-Type': 'application/json',
  };

  defaultData: Partial<D>;

  defaultQuery: Partial<Q>;

  constructor({
    defaultData,
    defaultQuery,
    headers,
    method,
    url,
  }: Partial<IAxiosRequestOptions<M, D, Q>>) {
    this.defaultData = defaultData ?? ({} as D);
    this.defaultQuery = defaultQuery ?? ({} as Q);
    this.headers = headers ?? this.headers;
    this.method = method!;
    this.url = url!;
  }
}

export class AxiosGetRequestOptions<
  Q extends Dictionary = Dictionary,
> extends AxiosRequestOptions<METHOD.GET, any, Q> {
  constructor(
    params: Partial<Omit<IAxiosRequestOptions<METHOD.GET, any, Q>, 'method'>>,
  ) {
    super({ ...params, method: METHOD.GET });
  }
}

export class AxiosPostRequestOptions<
  D extends Dictionary = Dictionary,
  Q extends Dictionary = Dictionary,
> extends AxiosRequestOptions<METHOD.POST, D, Q> {
  constructor(
    params: Partial<Omit<IAxiosRequestOptions<METHOD.POST, D, Q>, 'method'>>,
  ) {
    super({ ...params, method: METHOD.POST });
  }
}

export class AxiosPutRequestOptions<
  D extends Dictionary = Dictionary,
  Q extends Dictionary = Dictionary,
> extends AxiosRequestOptions<METHOD.PUT, D, Q> {
  constructor(
    params: Partial<Omit<IAxiosRequestOptions<METHOD.PUT, D, Q>, 'method'>>,
  ) {
    super({ ...params, method: METHOD.PUT });
  }
}

export class AxiosPatchRequestOptions<
  D extends Dictionary = Dictionary,
  Q extends Dictionary = Dictionary,
> extends AxiosRequestOptions<METHOD.PATCH, D, Q> {
  constructor(
    params: Partial<Omit<IAxiosRequestOptions<METHOD.PATCH, D, Q>, 'method'>>,
  ) {
    super({ ...params, method: METHOD.PATCH });
  }
}

export class AxiosDeleteRequestOptions extends AxiosRequestOptions<METHOD.DELETE> {
  constructor(
    params: Partial<Omit<IAxiosRequestOptions<METHOD.DELETE>, 'method'>>,
  ) {
    super({ ...params, method: METHOD.DELETE });
  }
}
